import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Background from "../../assets/Images/background.jpg";
import Logo from "../../assets/Images/logo.png";
import CircularProgress from "@mui/material/CircularProgress";
import NavBar from "../../components/NavBar/NavBar";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import { format } from "date-fns";
import { Link, useNavigate } from "react-router-dom";
import {
  alphabetExp,
  numberExp,
  emailExp,
} from "../../utils/regularExpression";
import Copyright from "../../components/Copyrights/copyrights";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: `url(${Background})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(2, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  instructions: {
    marginBottom: 10,
    textAlign: "center",
    fontSize: 12,
    padding: 1,
    color: "gray",
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  }
}));

function isEmpty(obj) {
  if (obj == null) return true;

  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  if (typeof obj !== "object") return true;

  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

const Registration = () => {
  const classes = useStyles();

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    dob: null,
    genderId: "",
    mobileNo: "",
    email: "",
    degreeId: "",
  });

  const [formErrors, setFormErrors] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    genderId: "",
    mobileNo: "",
    email: "",
    degreeId: "",
  });

  const [todaysDate, setTodaysDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [genderData, setGenderData] = useState([]);
  const [degreeData, setDegreeData] = useState([]);
  const [successDialog, setSuccessDialog] = useState(false);

  const handleSuccessDialog = () => {
    setSuccessDialog(!successDialog);
  };

  useEffect(() => {
    const getGenderData = async () => {
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonGendersView`;
      try {
        const res = await fetch(url, { method: "GET" });
        if (!res.ok) throw res;
        const json = await res.json();
        setGenderData(json.DATA);
      } catch (error) {
        console.log(error);
      }
    };

    const getDegreesData = async () => {
      let data = [];
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAcademicsDegreeProgramsView`;
      try {
        const res = await fetch(url, { method: "GET" });
        if (!res.ok) throw res;
        const json = await res.json();
        const resData = json.DATA || [];
        if (resData.length > 0) {
          for (let i = 0; i < resData.length; i++) {
            if (!isEmpty(resData[i])) {
              data.push({ id: "", label: resData[i].department });
            }
            for (let j = 0; j < resData[i].degrees.length; j++) {
              if (!isEmpty(resData[i].degrees[j])) {
                data.push({
                  id: resData[i].degrees[j].id,
                  label: resData[i].degrees[j].label,
                  isActive: resData[i].degrees[j].isActive
                });
                console.log("Log G", resData[i].degrees[j]);
              }
            }
          }
        }
        setDegreeData(data);
      } catch (error) {
        console.log("myData", error);
      }
    };

    const setTodayDate = () => {
      var date = new Date();
      var dd = String(date.getDate()).padStart(2, '0');
      var mm = String(date.getMonth() + 1).padStart(2, '0');
      var yyyy = date.getFullYear();
      setTodaysDate(dd + '/' + mm + '/' + yyyy);
    };

    getGenderData();
    getDegreesData();
    setTodayDate();
  }, []);

  const resetForm = () => {
    setForm({
      firstName: "",
      lastName: "",
      dob: null,
      genderId: "",
      mobileNo: "",
      email: "",
      degreeId: "",
    });
    setFormErrors({
      firstName: "",
      lastName: "",
      dob: "",
      genderId: "",
      mobileNo: "",
      email: "",
      degreeId: "",
    });
    setIsLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let regex = "";

    // Create copies of state to update
    const nextForm = { ...form };
    const nextFormErrors = { ...formErrors };

    switch (name) {
      case "degreeId":
        break;
      case "firstName":
      case "lastName":
        regex = new RegExp(alphabetExp);
        if (value && !regex.test(value)) {
          return;
        }
        break;
      case "mobileNo":
        regex = new RegExp(numberExp);
        if (value && !regex.test(value)) {
          return;
        }
        break;
      default:
        break;
    }

    nextForm[name] = value;
    nextFormErrors[name] = "";

    setForm(nextForm);
    setFormErrors(nextFormErrors);
  };

  const handleDateChange = (date) => {
    const nextForm = { ...form };
    const nextFormErrors = { ...formErrors };

    nextForm["dob"] = date;
    nextFormErrors["dob"] = "";

    setForm(nextForm);
    setFormErrors(nextFormErrors);
  };

  const isFormValid = () => {
    const nextFormErrors = { ...formErrors };
    let isValid = true;

    if (!form.firstName.trim()) {
      nextFormErrors.firstName = "First Name is Required";
      isValid = false;
    } else {
      nextFormErrors.firstName = "";
    }
    if (!form.lastName.trim()) {
      nextFormErrors.lastName = "Last Name is Required";
      isValid = false;
    } else {
      nextFormErrors.lastName = "";
    }
    if (!form.dob) {
      nextFormErrors.dob = "Date of Birth is Required";
      isValid = false;
    } else {
      nextFormErrors.dob = "";
    }
    if (!form.genderId) {
      nextFormErrors.genderId = "Please select gender.";
      isValid = false;
    } else {
      nextFormErrors.genderId = "";
    }
    if (!form.mobileNo) {
      nextFormErrors.mobileNo = "Mobile Number is required.";
      isValid = false;
    } else {
      if (!form.mobileNo.startsWith("03") || form.mobileNo.length < 11) {
        nextFormErrors.mobileNo =
          "Please enter valid mobile number e.g 03001234567";
        isValid = false;
      }
    }
    if (!form.email) {
      nextFormErrors.email = "Email is required.";
      isValid = false;
    } else {
      const regex = new RegExp(emailExp);
      if (!regex.test(form.email)) {
        nextFormErrors.email =
          "Please enter valid email address e.g user@domain.com";
        isValid = false;
      }
    }
    if (!form.degreeId) {
      nextFormErrors.degreeId = "Please select a degree for applying.";
      isValid = false;
    } else {
      nextFormErrors.degreeId = "";
    }

    setFormErrors(nextFormErrors);
    return isValid;
  };

  const handleSubmitButtonClick = () => {
    const isValid = isFormValid();
    if (isValid) {
      document.getElementById("submit-button").click();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    setIsLoading(true);

    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonUsersSave`;

    try {
      const res = await fetch(url, { method: "POST", body: data });
      if (!res.ok) throw res;
      const json = await res.json();

      if (json.CODE === 1) {
        handleSuccessDialog();
        resetForm();
      } else {
        if (json.SYSTEM_MESSAGE != null && json.SYSTEM_MESSAGE.indexOf('email_UNIQUE') > -1) {
          alert("The email address you have entered is already registered.");
        } else {
          alert("Operation Failed !\n" + json.SYSTEM_MESSAGE);
        }
      }
    } catch (error) {
      alert(error);
    }

    setIsLoading(false);
  };

  const dobForDb = form.dob ? format(form.dob, "dd-MM-yyyy") : null;

  return (
    <Fragment>
      <Dialog
        open={successDialog}
        onClose={handleSuccessDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Success"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Thank you for registering. Your online admission account has been created successfully.
            You can now login to your account by entering the username and password sent to your given email address.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSuccessDialog} color="primary">
            Close
          </Button>
          <Button onClick={() => window.location.replace("#/login")} color="primary" >
            Login
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container component="main" className={classes.root}>
        <NavBar logo={Logo} title="University College London" />
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          style={{ marginTop: 55 }}
        >
          <div className={classes.container}>
            <div className={classes.paper}>
              <Typography style={{ marginTop: 10 }} component="h1" variant="h5">
                Applicant Registration
              </Typography>
              <Typography
                className={classes.instructions}
                component="h5"
                variant="body2"
              >
                Welcome to UCL Admissions<br></br>
                <i>Please enter the information requested below to register</i>
              </Typography>
              <form
                noValidate
                onSubmit={handleSubmit}
                className={classes.form}
              >
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      id="firstName"
                      label="First Name"
                      name="firstName"
                      onChange={handleChange}
                      value={form.firstName}
                      error={!!formErrors.firstName}
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      id="lastName"
                      label="Last Name"
                      name="lastName"
                      onChange={handleChange}
                      value={form.lastName}
                      error={!!formErrors.lastName}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DatePicker
                      views={["year", "month", "day"]}
                      openTo={"year"}
                      disableFuture
                      label="Date of Birth"
                      format="dd-MMM-yyyy"
                      value={form.dob}
                      onChange={handleDateChange}
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          fullWidth: true,
                          required: true,
                          error: !!formErrors.dob,
                          helperText: formErrors.dob
                        }
                      }}
                    />
                    <input name="dateOfBirth" value={dobForDb || ""} type="hidden" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      id="genderId"
                      name="genderId"
                      required
                      fullWidth
                      select
                      label="Gender"
                      variant="outlined"
                      onChange={handleChange}
                      value={form.genderId}
                      error={!!formErrors.genderId}
                    >
                      {genderData.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="mobileNo"
                      label="Mobile Number"
                      id="mobileNo"
                      onChange={handleChange}
                      inputProps={{
                        maxLength: 11,
                      }}
                      value={form.mobileNo}
                      error={!!formErrors.mobileNo}
                      helperText={form.mobileNo && formErrors.mobileNo}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      required
                      fullWidth
                      name="email"
                      label="Email"
                      id="email"
                      onChange={handleChange}
                      value={form.email}
                      error={!!formErrors.email}
                      helperText={form.email && formErrors.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="degreeId"
                      name="degreeId"
                      required
                      fullWidth
                      select
                      label="Applying For"
                      variant="outlined"
                      onChange={handleChange}
                      value={form.degreeId}
                      error={!!formErrors.degreeId}
                    >
                      {degreeData.map((item, index) => {
                        return (
                          <MenuItem
                            key={index}
                            disabled={!item.id || item.isActive == 0}
                            value={item.id}
                          >
                            {item.label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <input
                    id="submit-button"
                    type="submit"
                    style={{ display: "none" }}
                  />
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    style={{ backgroundColor: `${isLoading ? "#6272ce" : ""}` }}
                    onClick={handleSubmitButtonClick}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <CircularProgress style={{ color: "white" }} size={24} />
                    ) : (
                      "Register"
                    )}
                  </Button>
                  <Grid container justifyContent="center">
                    <Grid item>
                      <Link to="/ucl/login" variant="body2">
                        {"Already have an account."}
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            </div>
            <div style={{ paddingBottom: 25 }}>
              <Copyright />
            </div>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Registration;
